module.exports = __webpack_public_path__ + "e869e03ae9d793031b63c05216374eb1.svg";